class LatestReleaseSendDate {
  insertToLocalStorage(latestReleaseSendDate: string): void {
    // ローカルストレージに最新のリリースの配信日時を入れる
    localStorage["latest-release-send-date"] = latestReleaseSendDate;
  }
  getFromLocalStorage(): Date {
    return new Date(localStorage.getItem("latest-release-send-date"));
  }
}
export default LatestReleaseSendDate;
